<template>
  <el-dialog
    title="添加角色"
    :visible.sync="outerVisible"
    width="500px"
    @close="offDialog"
    style="text-align:left;"
  >
    <el-form ref="forms" :model="form" :rules="rules" label-width="80px" label-position="left">
      <el-form-item label="角色名称" prop="name">
        <el-col :xs="24" :sm="24" :md="24" :lg="20">
          <el-input v-model="form.name" placeholder="1 - 10 个字"></el-input>
        </el-col>
      </el-form-item>
      <el-form-item label="操作权限" prop="resource">
        <el-tree
          :data="dataForm"
          show-checkbox
          default-expand-all
          node-key="menuId"
          ref="tree"
          highlight-current
          :props="defaultProps"
          @check="treeFun(dataForm)"
        ></el-tree>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="outerVisible = false">取 消</el-button>
      <el-button type="primary" @click="commitActor">添加</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { getLimitList, addRole, getRole } from "../../../api/index";
export default {
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入角色名称"));
      } else if (!/^\S{1,10}$/.test(value)) {
        callback(new Error("角色名过长 , 请重新输入"));
      } else {
        callback();
      }
    };
    return {
      form: {
        name: ""
      },
      outerVisible: false,
      rules: {
        name: [{ validator: validatePass, trigger: "blur" }]
      },
      menuList: [],
      select: false,
      dataForm: [],
      defaultProps: {
        children: "sonMenu",
        label: "name"
      }
    };
  },
  mounted() {
    this.getRoleFun();
  },
  methods: {
    //获取角色方法
    getRoleFun() {
      getRole()
        .then(res => {})
        .catch(error => {});
    },
    //获取当前选中id列表
    treeFun(data) {
      this.menuList = this.$refs.tree.getCheckedKeys();
    },
    //获取权限列表
    init() {
      this.outerVisible = true;
      let data = {
        roleId: ""
      };
      getLimitList(data)
        .then(res => {
          this.dataForm = res.data;
        })
        .catch(error => {});
    },
    // 提交添加角色
    commitActor() {
      this.menuList = this.getCheckedKeys(this.dataForm, this.$refs.tree.getCheckedKeys(), 'menuId');
      let data = {
        menuList: this.menuList,
        roleId: JSON.parse(localStorage.loginData).roleId,
        roleName: this.form.name
      };
      addRole(data)
        .then(res => {
          this.outerVisible = false;
          this.$emit("addactor");
          this.$message({
            message: "创建成功",
            type: "success"
          });
          this.$emit("getRoleFun");
        })
        .catch(error => {});
    },
    offDialog() {
      this.$refs["forms"].resetFields();
    },
    getCheckedKeys(data, keys, key) {
      var res = [];
      recursion(data, false);
      return res;

      // arr -> 树形总数据
      // keys -> getCheckedKeys获取到的选中key值
      // isChild -> 用来判断是否是子节点
      function recursion(arr, isChild) {
        var aCheck = [];
        for (var i = 0; i < arr.length; i++) {
          var obj = arr[i];
          aCheck[i] = false;
          if (obj.sonMenu) {
            aCheck[i] = recursion(obj.sonMenu, true) ? true : aCheck[i];
            if (aCheck[i]) {
              res.push(obj[key]);
            }
          }

          for (var j = 0; j < keys.length; j++) {
            if (obj[key] == keys[j]) {
              aCheck[i] = true;
              if (res.indexOf(obj[key]) == -1) {
                res.push(obj[key]);
              }
              break;
            }
          }
        }
        if (isChild) {
          return aCheck.indexOf(true) != -1;
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped >
/deep/.el-dialog {
  .el-dialog__header {
    padding: 18px;
    border-bottom: 1px solid #f4f4f4;
    .el-dialog__title {
      font-size: 14px;
    }
  }
  .el-dialog__body {
    padding: 20px 32px !important;
    padding-bottom: 0px !important;
    .el-form {
      .el-input {
        .el-input__inner {
          height: 38px;
          width: 270px;
        }
      }
      .el-form-item__label {
        width: 80px;
        color: #323232;
        font-weight: 500;
      }
      .el-tree {
        width: 328px;
        padding: 20px;
        border: 1px solid #f4f4f4;
        color: #323232;
        font-weight: 500;
      }
    }
  }
  .dialog-footer {
    .el-button {
      width: 80px;
    }
    .el-button--primary {
      background-color: #2479ed;
    }
    .el-button--default {
      background-color: #e5e5e5;
    }
  }
}
.iplist {
  width: 100%;
  height: 100px;
  background-color: red;
}
.PermissOperation {
  width: 300px;
  border: 1px solid #eee;
  list-style: none;
}
.PermissOperation ul {
  list-style: none;
}
.pointers {
  cursor: pointer;
}
</style>
